import { Locales } from './locales';

import en from './en.json';
import ru from './ru.json';
import es from './es.json';
import tr from './tr.json';
import uk from './uk.json';

export const messages = {
  [Locales.EN]: en,
  [Locales.RU]: ru,
  [Locales.ES]: es,
  [Locales.TR]: tr,
  [Locales.UA]: uk,
};

export const defaultLocale = Locales.EN;
